
<template>

 <v-card>
     <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>
     <v-btn
                  @click="backTodisciplinList"
                  class="mx-2"
                  fab
                  dark
                  color="primary"
                  v-on="on"
                >
          <v-icon dark>arrow_back</v-icon>
        </v-btn>
   <v-card-title>
      Lista dos Estudantes na turma

        <v-chip
              v-if="true"
              class="ma-2"
              close
              color="pink"
              label
              outlined
              >
              {{(!this.$store.state.fromMinhaTurmas)?this.$store.state.objturma.turmadescricao:this.$store.state.objturma.descricao}}
          </v-chip>

      <v-spacer></v-spacer>
    <img @click="teste()" style="margin-left:30px"  width="30px"  src="../../assets/download.png">
    </v-card-title>
    <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>
  <v-data-table
    :headers="headers"
    :items="listEstudantfromPauta"
    :items-per-page="50"
    class="elevation-1">

    <template v-slot:item.action="{ item }">
      <v-menu
      bottom
      origin="center center"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          fab dark color="teal"
          style="color:white"
          v-on="on"
        >
          <v-icon>menu</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="editItem(item)"> <v-img  style="color:green" src="../../assets/boletim.jpg" width="80px"  class="mr-2" @click="editItem(item)"></v-img> </v-list-item>
        <v-list-item @click="item"><v-icon>fast_forward</v-icon>Transferência</v-list-item>
        <v-list-item @click="Mudar_Classe(item)"><v-icon>crop_rotate</v-icon>Mudar-Classe</v-list-item>
        <v-list-item @click="Mudar_Turma(item)"><v-icon>crop_rotate</v-icon>Mudar-Turma</v-list-item>
      </v-list>
    </v-menu>

      <!--<v-img  style="color:green" src="../assets/boletim.jpg" width="80px"  class="mr-2" @click="editItem(item)"></v-img>-->
    </template>
  ></v-data-table>

  <!--======================================= MODAL =======================================-->

      <v-dialog
      v-model="dialogo"
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline"><v-icon color="blue">info</v-icon>Mudança de Classe</v-card-title>

        <v-card-text>
           <v-row>

               <v-col cols="6">
                   <v-text-field
                    v-model="editedItem_mudar_classe.nome"
                    label="Nome do estudante"
                    :disabled="true"
                  ></v-text-field>
               </v-col>

                <v-col cols="6">
                      <v-select
                      v-model="classe_selecionada"
                      :items="classes"
                      label="Nova Classe"
                    ></v-select>
               </v-col>

           </v-row>
           <v-row>

               <v-col cols="6">
                    <label> Classe Actual: {{_classe}}</label>
               </v-col>
               <v-col cols="6">
                     <v-progress-circular
                      v-if="progresso"
                      indeterminate
                      color="green"
                  ></v-progress-circular>
               </v-col>
           </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-1"
            text
            @click="dialogo = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            :disabled="classe_selecionada === ''"
            @click="ContinuarMudanca()"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

<!-- ===================================== FIM DO MODAL ================================-->

<!--======================================= MODAL==========Mudar Turma-Curso =======================================-->

      <v-dialog
      v-model="dialogo_turma"
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline"><v-icon color="blue">info</v-icon>Mudança de Turma</v-card-title>

        <v-card-text>
           <v-row>

               <v-col cols="6">
                   <v-text-field
                    v-model="editedItem_mudar_classe.nome"
                    label="Nome do estudante"
                    :disabled="true"
                  ></v-text-field>
               </v-col>

                <v-col cols="6">
                      <v-select
                      v-model="turma_selecionada"
                      :items="turmasFiltered"
                      item-value="idTurma"
                      item-text="idTurma"
                      label="Nova Turma"
                    ></v-select>
               </v-col>

           </v-row>
           <v-row>

               <v-col cols="6">
                    <label> Turma Actual: {{editedItem_mudar_classe.idTurma}}</label>
               </v-col>
               <v-col cols="6">
                     <v-progress-circular
                      v-if="progresso"
                      indeterminate
                      color="green"
                  ></v-progress-circular>
               </v-col>
           </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-1"
            text
            @click="dialogo_turma = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            :disabled="turma_selecionada === ''"
            @click="ContinuarMudancaTurma()"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

<!-- ===================================== FIM DO MODAL ================================-->

<!--=======================================================--========-->
  <template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
         Exportar para Excel - Deseja Continuar
        </v-card-title>

        <v-card-text>
            Clique para Continuar
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn style="background-color:red;color:white" @click="dialog=false">Cancelar</v-btn>
           <export-excel
                :data   = "listEstudantfromPauta"
              :fields="campos"
              >
          <v-btn @click="dialog=false">Continuar</v-btn>
        </export-excel>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<!--=================================================================-->

 </v-card>
</template>

<script>
import axios from '../../plugins/axios'
import pdf from 'vue-pdf'
const ls = require('local-storage')

export default {
  components: {
    pdf
  },
  data: () => ({
    formValid: true,
    items: [
      { title: 'Click Me' },
      { title: 'Click Me' },
      { title: 'Click Me' },
      { title: 'Click Me 2' }
    ],
    on: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 20) || 'nota invalida',
      v => !isNaN(v) || 'not number ',

      v => (v.length <= 2) || 'valor inválido'

    ],

    json_meta: [
      [
        {
          'key': 'charset',
          'value': 'utf-8'
        }
      ]
    ],

    campos: {
      'Nome Completo': 'nome',
      'Número de Matricula': 'idMAtricula',
      'Resultado': 'resultado'
    },
    headers: [
      {
        text: 'Nome',
        align: 'start',
        sortable: false,
        value: 'nome'
      },
      { text: 'Matricula', value: 'idMAtricula' },
      { text: 'Resultado', value: 'resultado' },
      { text: 'Operações permitidas', value: 'action', sortable: false }

    ],
    text: '',
    editedpk: false,
    progresso: false,
    disciplinas: [],
    _classe: '',
    dialog: false,
    dialogoDisabilita: false,
    dialogo: false,
    idanoacademico: 0,
    turmasFiltered: [],
    turmasAll: [],
    offset: true,
    tumaSelect: '',
    iddisciplina: 0,
    btn_description: '',
    turma_selecionada: '',
    publicar_status: false,
    isLoading: true,
    idturma: 0,
    dialogo_turma: false,
    closeOnClick: true,
    item: 1,
    listaPautasBloquadas: [],
    classe_selecionada: '',
    btn_activacao: false,
    listaDeClassesPorLancarNotas: [],
    listEstudantfromPauta: [],
    editedIndex: -1,
    editedItem: {
      pkpauta: 0,
      p1_notaMac: 0,
      p1_nota: 0,
      p1_nota2: 0,
      p1_MD: 0,
      p2_notaMac: 0,
      p2_nota: 0,
      p2_nota2: 0,
      p2_MD: 0,
      p3_notaMac: 0,
      p3_nota: 0,
      p3_MD: 0,
      pg: 0,
      ca: 0,
      mfd: 0
    },

    editedItem_mudar_classe: {
      nome: '',
      idAno_Academico: 0,
      idMAtricula: '',
      idTurma: '',
      idCurso: 0

    },
    classes: [
      '10ª Classe',
      '11ª Classe',
      '12ª Classe',
      '13ª Classe'
    ]
  }),
  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },

  watch: {

    listaDeClassesPorLancarNotas () {
      this.$store.state.isloading = false
    }
  },
  created () {
    this.pautaByTurma()
    this.initializeturmasAll()
  },

  methods: {
    classe (idanoacademico) {
      if (idanoacademico === 1) {
        this._classe = '10ª Classe'
      }
      if (idanoacademico === 2) {
        this._classe = '11ª Classe'
      }
      if (idanoacademico === 3) {
        this._classe = '12ª Classe'
      }
      if (idanoacademico === 4) {
        this._classe = '13ª Classe'
      }

      this.idanoacademico = idanoacademico
    },

    IDano_academico (classe) {
      if (classe === '10ª Classe') {
        return 1
      }
      if (classe === '11ª Classe') {
        return 2
      }
      if (classe === '12ª Classe') {
        return 3
      }
      if (classe === '13ª Classe') {
        return 4
      }
    },

    teste () {
      this.dialog = true
    },
    loadprogressbar () {
      this.$store.state.isloading = true
    },

    backToTurmas () {
      this.$router.push('painelClassTurma')
    },

    bt_edit (item) {
      this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedpk = item.pkpauta
      this.editedItem.trimestre = this.$store.state.idperfilpauta
      this.editedItem.pkpauta = item.pkpauta

      setTimeout(() => {}, 1000)
    },
    MostrarDialogo () {
      this.dialog = true
    },

    MostrarDialogoDisabilitar () {
      this.dialogoDisabilita = true
    },

    async  ContinuarMudanca () {
      this.progresso = true
      let dados =
        {
          idmatricula: this.editedItem_mudar_classe.idMAtricula,
          idanoacademico: this.IDano_academico(this.classe_selecionada)
        }

      if (dados !== null) {
        try {
          this.msg = await axios
            .post('/mudarClasse', dados)
            .then(res => res.data)
          this.progresso = false
          this.text = 'Classe Alterada com sucesso'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 4000 })
          this.progresso = false
          this.dialogo = false
        } catch (error) {
          this.progresso = false
        }
      }
    },

    async ContinuarMudancaTurma () {
      this.progresso = true
      let dados = {
        idmatricula: this.editedItem_mudar_classe.idMAtricula,
        idturmaOrigem: this.editedItem_mudar_classe.idTurma,
        idturmaDestino: this.turma_selecionada
      }

      try {
        let msg = await axios
          .post('/mudarTurma', dados)
          .then(res => res.data)
        this.progresso = false
        this.text = msg
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 4000 })
        this.progresso = false
        this.dialogo_turma = false
      } catch (error) {
        this.progresso = false
        this.dialogo_turma = false
      }
    },
    bt_save (editedItem) {
      // this.editedIndex = this.listEstudantfromPauta.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      editedItem.p1_MD = Math.round(
        (Number(editedItem.p1_notaMac) +
          Number(editedItem.p1_nota) +
          Number(editedItem.p1_nota2)) /
          3
      )
      editedItem.p2_MD = Math.round(
        (Number(editedItem.p2_notaMac) +
          Number(editedItem.p2_nota) +
          Number(editedItem.p2_nota2)) /
          3
      )
      editedItem.p3_MD = Math.round(
        (Number(editedItem.p3_notaMac) +
          Number(editedItem.p3_nota)) /
          2
      )
      if (this.formValid) {
        this.save(editedItem)
        Object.assign(this.listEstudantfromPauta[this.editedIndex], editedItem)

        this.editedpk = 0
      }
      setTimeout(() => {}, 1000)
    },
    backTodisciplinList () {
      if (!this.$store.state.fromMinhaTurmas) { this.$router.push('painelClassTurma') } else { this.$router.push('minhas-turmas') }
    },
    backToTurmaList () {
      this.disciplinas = []
    },

    async turmaFindWithEstudanteCount (idclasse) {
      try {
        this.listaDeClassesPorLancarNotas = await axios
          .get('/turmaFindWithEstudanteCount/' + 'all') // idclasse JyUn JQ==
          .then(res => res.data)
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
      this.listEstudantfromPauta = []
    },
    async save (editedItem) {
      const ls = require('local-storage')
      var params = {
        p1_notaMac: editedItem.p1_notaMac,
        p1_nota: editedItem.p1_nota,
        p1_nota2: editedItem.p1_nota2,
        p1_MD: editedItem.p1_MD,
        p2_notaMac: editedItem.p2_notaMac,
        p2_nota: editedItem.p2_nota,
        p2_nota2: editedItem.p2_nota2,
        p2_MD: editedItem.p2_MD,
        p3_notaMac: editedItem.p3_notaMac,
        p3_nota: editedItem.p3_nota,
        p3_MD: editedItem.p3_MD,
        pg: editedItem.pg,
        ca: editedItem.ca,
        mfd: editedItem.mfd,
        autor: editedItem.autor,
        pkpauta: editedItem.pkpauta,
        trimestre: editedItem.trimestre
      }

      try {
        let msg = await axios.post('/lancarNota', params).then(res => res.data)
        // this.text = msg[1].insertId
        this.text = msg

        try {
          if (msg.affectedRows >= 1) {
            this.text = msg.affectedRows + ' gravado(s) com sucesso'
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgSucess',
              timeout: 2000
            })
          }
        } catch (error) {

        }
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } catch (error) {}
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } catch (error) {}

        if (this.editedIndex > -1) {
          //  Object.assign(this.estudantes[this.editedIndex], this.editedItem)
        } else {
          this.estudantes.push(this.editedItem)
          // console.log("this.editedItem: "+this.editedItem.nome)
        }
        //  this.close();
      } catch (error) {
        console.log('eroooo: ' + error)
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text + ' - ' + error,
          classMessage: 'msgError',
          timeout: 8000
        })
      } finally {
      }
    },

    async pautaByTurma (obj) {
      // carrega turma apartir de bauta  Turma
      this.isLoading = true

      try {
        this.listEstudantfromPauta = await axios

          .get('/ListaEstudantes/' + this.$store.state.objturma.id)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        // this.isLoading = false
        this.isLoading = false
        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async initializeturmasAll () {
    //  turmaFindWithEstudanteCount
      const ls = require('local-storage')
      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll/' + this.idclasse)
          .then(res => res.data)
        console.log(this.turmasFiltered)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async PublicarPauta () {
      const valores =
          {
            turma: this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma,
            disciplina: this.$store.state.disciplina,
            bloquear: 1,
            publicar: 1,
            idControlopauta: 0
          }

      // Consumindo a API
      try {
        let valor = await axios

          .post('/bloquearPauta', valores)
          .then(res => res.data)
        let text = 'Pauta publicada com sucesso'
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
        this.dialog = false

        this.$store.state.bloqueado = []
        // CarregaPauta
        this.CarregaPautas()
        this.verificaPautas()
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async DesbloquearPauta () {
      // Verificando se o Id esta disponivel
      if (this.$store.state.Controlopauta != null) {
        // CONSUMINDO A API ----  Passando a Id
        const valores =
            {
              turma: this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma,
              disciplina: this.$store.state.disciplina,
              bloquear: 0,
              publicar: 0,
              idControlopauta: this.$store.state.Controlopauta
            }

        try {
          let valor = await axios

            .post('/bloquearPauta', valores)
            .then(res => res.data)
          let text = 'Pauta Bloqueada com sucesso'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
          this.dialog = false

          this.$store.state.bloqueado = []
          // CarregaPauta
          this.CarregaPautas()
          this.verificaPautas()

          this.dialogoDisabilita = false
        } catch (error) {
          // this.isLoading = false

          // this.text = error
          this.$store.dispatch('textMessage', {
            msg: error,
            classMessage: 'msgError',
            timeout: 3000
          })
        }
      }
    },

    Mudar_Turma (item) {
      this.dialogo_turma = true
      this.editedItem_mudar_classe = Object.assign({}, item)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === this.editedItem_mudar_classe.idCurso && t.idAno_Academico === this.editedItem_mudar_classe.idAno_Academico)
    },

    async CarregaPautas () {
      if (!this.$store.state.bloqueado.length) {
        try {
          this.$store.state.bloqueado = await axios

            .get('/ListarPautaBloqueada')
            .then(res => res.data)
          console.log(this.$store.state.bloqueado)
        } catch (error) {
          // this.isLoading = false

          // this.text = error
          this.$store.dispatch('textMessage', {
            msg: error,
            classMessage: 'msgError',
            timeout: 3000
          })
        }
      }
    },

    verificaPautas () {
      this.listaPautasBloquadas = this.$store.state.bloqueado.filter(block => block.turma == this.$store.state.objturma.descricao + '-' + this.$store.state.objturma.pkTurma && block.disciplina == this.$store.state.disciplina && block.publicar == 1 && block.bloquear == 1)
      if (this.listaPautasBloquadas.length) {
        this.$store.state.Controlopauta = this.listaPautasBloquadas[0].idControlopauta
        if (ls.get('role') === 'ROLE_PROF') {
          this.publicar_status = true
          this.btn_activacao = true
          this.btn_description = 'Mini Pauta Bloqueada'
        } else {
          this.publicar_status = true
          this.btn_activacao = false
          this.btn_description = 'Mini Pauta Bloqueada'
        }
      } else {
        this.publicar_status = false
        this.btn_activacao = false
        this.btn_description = 'Publicar'
      }
    },

    editItem (item) {
      this.$store.state.objAluno = item
      this.$router.push('Boletim')
    },

    async findDisciplinaInProfDisc (obj) {
      this.disciplinas = []
      this.$store.state.turma = obj.descricao
      this.$store.state.objturma = obj
      // console.log("vervcv rexmsg:"+ Object.values(obj))
      try {
        this.disciplinas = await axios

          .get('/findDisciplinaInProfDisc/' + obj.pkTurma)
          .then(res => res.data)
      } catch (error) {
        // this.isLoading = false

        // this.text = error
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async Mudar_Classe (item) {
      this.dialogo = true
      this.editedItem_mudar_classe = Object.assign({}, item)
      this.classe(this.editedItem_mudar_classe.idAno_Academico)
      let indice = this.classes.indexOf(this._classe)
      this.classes.splice(indice, 1)
      console.log(item)
    }
  }
}
</script>
